import { forwardRef, Fragment, RefObject } from 'react'

import { Tooltip } from '../General/Tooltip'
import { Icon } from '../Icon'

interface ScrollToProps {
  targetRef?: RefObject<HTMLDivElement>
  visible?: boolean
}

interface AvailableAreaProps {
  children: React.ReactNode
  buttonVisible: boolean
  targetRef?: RefObject<HTMLDivElement>
}

function ScrollToButton({ targetRef, visible }: ScrollToProps) {
  if (!visible) return

  return (
    <Fragment>
      <Tooltip content='Back to Top' placement='top'>
        <button
          className='fixed bottom-4 left-5 z-[999] flex h-10 w-10 items-center justify-center rounded-[30px] border border-brand-gray-300 bg-white shadow-xl lg:left-auto lg:right-12'
          onClick={() => {
            targetRef?.current &&
              targetRef?.current.scrollIntoView({
                behavior: 'smooth',
                block: 'start',
              })
          }}
        >
          <Icon name='chevron-up-outline' className='h-4 w-4 text-brand-gray-500' />
        </button>
      </Tooltip>
    </Fragment>
  )
}

const ScrollToAnchor = forwardRef<HTMLDivElement>((_, ref) => <div ref={ref} />)
ScrollToAnchor.displayName = 'ScrollToAnchor'

const AvailableArea = forwardRef<HTMLDivElement, AvailableAreaProps>(
  ({ children, buttonVisible, targetRef }, ref) => (
    <div ref={ref}>
      {children}

      <ScrollToButton targetRef={targetRef} visible={buttonVisible} />
    </div>
  )
)
AvailableArea.displayName = 'AvailableArea'

const ScrollTo = {
  Anchor: ScrollToAnchor,
  AvailableArea,
}

export default ScrollTo
